/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourCardFailedMutationVariables = {
    tourId: string;
};
export type TourCardFailedMutationResponse = {
    readonly tourDelete: {
        readonly clientMutationId: string | null;
    };
};
export type TourCardFailedMutation = {
    readonly response: TourCardFailedMutationResponse;
    readonly variables: TourCardFailedMutationVariables;
};



/*
mutation TourCardFailedMutation(
  $tourId: ID!
) {
  tourDelete(input: {tourId: $tourId}) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tourId",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TourDeletePayload",
    "kind": "LinkedField",
    "name": "tourDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourCardFailedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourCardFailedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ff85756cb25af2ae790996462d72d024",
    "id": null,
    "metadata": {},
    "name": "TourCardFailedMutation",
    "operationKind": "mutation",
    "text": "mutation TourCardFailedMutation(\n  $tourId: ID!\n) {\n  tourDelete(input: {tourId: $tourId}) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '4567779cff881c288ae950496d1ab979';
export default node;
